import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link
                to="/"
                className="inline-block text-2xl font-heading font-semibold tracking-tight text-background-50 hover:text-primary-400 transition-colors duration-200 mb-4"
              >
                色彩美学
              </Link>
              <p className="text-background-400 text-sm leading-relaxed mt-3 max-w-xs">
                专注于女性网站色彩设计的专业知识平台，帮助设计师打造高颜值、高转化的女性向网站。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">内容分类</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">快速链接</h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="/about#contact"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    联系我们
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">关注我们</h4>
              <p className="text-sm text-background-400 mb-4">
                获取最新的女性网站色彩设计资讯与灵感
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                  aria-label="小红书"
                  rel="nofollow"
                >
                  <i className="ri-bookmark-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 色彩美学 ColorAesthetics. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}